import { watchAllowShopDev } from 'containers/Admin/GeneralSettingsManagement/store/saga/watchAllowleShopDev';
import { watchGetUserSettings } from 'containers/Admin/GeneralSettingsManagement/store/saga/watchGetUserSettings';

export const sagasGeneralManager = [watchAllowShopDev, watchGetUserSettings];
